import NotificationPrompt from './NotificationPrompt';

export default NotificationPrompt;

